export { subscribe, getSinkError } from './subscribe';
